var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('b-modal',{ref:"popup",attrs:{"hide-footer":""}},[_c('b-progress',{attrs:{"max":_vm.max_value,"height":"2rem"}},[_c('b-progress-bar',{attrs:{"value":_vm.current_value}},[_c('span',[_vm._v("Progress: "),_c('strong',[_vm._v(_vm._s(_vm.current_value.toFixed(2))+" / "+_vm._s(_vm.max_value))])])])],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }